import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/drafts/InlineAutocomplete/InlineAutocomplete.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {InlineAutocomplete} from '@primer/react/drafts'
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`InlineAutocomplete`}</inlineCode>{` component extends an `}<inlineCode parentName="p">{`Input`}</inlineCode>{` or `}<inlineCode parentName="p">{`Textarea`}</inlineCode>{` component to provide inline suggestions, similar to those provided by a code editor.`}</p>
    <h2>{`Examples`}</h2>
    <Note variant="warning" mdxType="Note">
      <p>{`Input components `}<strong parentName="p">{`must always`}</strong>{` be accompanied by a corresponding label to improve support for assistive
technologies. Examples below are provided for conciseness and may not reflect accessibility best practices.`}</p>
      <p><inlineCode parentName="p">{`InlineAutocomplete`}</inlineCode>{` can be used with the `}<a parentName="p" {...{
          "href": "/FormControl"
        }}><inlineCode parentName="a">{`FormControl`}</inlineCode></a>{` component to render a corresponding label.`}</p>
    </Note>
    <h3>{`Multi-line input`}</h3>
    <p>{`Try typing a `}<inlineCode parentName="p">{`#`}</inlineCode>{` symbol to see suggestions. Use `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` or click to apply a suggestion.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const options = ['javascript', 'typescript', 'css', 'html', 'webassembly']

const SimpleExample = () => {
  const [suggestions, setSuggestions] = React.useState([])

  return (
    <InlineAutocomplete
      triggers={[{triggerChar: '#'}]}
      suggestions={suggestions}
      onShowSuggestions={({query}) => setSuggestions(options.filter(tag => tag.includes(query)))}
      onHideSuggestions={() => setSuggestions([])}
    >
      <Textarea />
    </InlineAutocomplete>
  )
}

render(SimpleExample)
`}</code></pre>
    <h3>{`Single-line input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const options = ['javascript', 'typescript', 'css', 'html', 'webassembly']

const SimpleExample = () => {
  const [suggestions, setSuggestions] = React.useState([])

  return (
    <InlineAutocomplete
      triggers={[{triggerChar: '#'}]}
      suggestions={suggestions}
      onShowSuggestions={({query}) => setSuggestions(options.filter(tag => tag.includes(query)))}
      onHideSuggestions={() => setSuggestions([])}
    >
      <TextInput />
    </InlineAutocomplete>
  )
}

render(SimpleExample)
`}</code></pre>
    <h3>{`Labelled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const options = ['javascript', 'typescript', 'css', 'html', 'webassembly']

const SimpleExample = () => {
  const [suggestions, setSuggestions] = React.useState([])

  return (
    <FormControl>
      <FormControl.Label>Example</FormControl.Label>
      <InlineAutocomplete
        triggers={[{triggerChar: '#'}]}
        suggestions={suggestions}
        onShowSuggestions={({query}) => setSuggestions(options.filter(tag => tag.includes(query)))}
        onHideSuggestions={() => setSuggestions([])}
      >
        <Textarea />
      </InlineAutocomplete>
    </FormControl>
  )
}

render(SimpleExample)
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: false,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      